export default __webpack_public_path__ + "static/media/WPNSA_2020_COVER.1a01aab0.jpg";